import '../../../lib/initFontAwesome'
import '../../styles/globalRules.global.sass'
import '@stripe/stripe-js'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { addLocaleData } from 'react-intl'
import { AppWrapper } from '../../components/app_wrapper'
import { BATCH_JOB_LIST } from '../../components/worker/jobs'
import { createBrowserHistory } from 'history'
import { DownloadsListener } from '../../components/browser_downloads'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorMessage } from '../../components/error'
import { hot } from 'react-hot-loader'
import { loadFromLocalStorage, removeFromLocalStorage } from 'spa/shared/utils'
import { ModalWarning } from '../../components/warnings'
import { Notifications } from '../../components/notifications'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { render } from 'react-dom'
import { ConnectedRouter as Router } from 'connected-react-router'
import { ScrollbarMemory } from '../../components/scrollbar_memory/scrollbar_memory'
import BatchWorker from '../../components/worker/batchWorker'
import configureStore from './configureStore'
import de from 'react-intl/locale-data/de'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import ForgotPasswordModal from '../../components/forgot_password_modal'
import Init from './init'
import IntlGlobalProvider from '../../shared/IntlGlobalProvider'
import ja from 'react-intl/locale-data/ja'
import KeyboardShortcutsModal from 'spa/components/keyboard_shortcuts_modal'
import LocaleProvider from 'spa/components/locale_provider'
import LoginModal from 'spa/components/login_modal'
import NewSignUp from 'spa/components/newsignup'
import PlaybackErrorModal from '../../components/player/playbackErrorModal'
import React, { StrictMode } from 'react'
import ResetPasswordModal from '../../components/reset_password_modal'
import Routes from './routes'
import ScrollToTop from '../../components/scroll/scroll_to_top'
import UpdatePasswordModal from '../../components/update_password_modal'

if (window.newrelic) {
  window.newrelic.wrapLogger(console, 'log', { level: 'info' })
  window.newrelic.wrapLogger(console, 'info', { level: 'info' })
  window.newrelic.wrapLogger(console, 'warn', { level: 'warn' })
  window.newrelic.wrapLogger(console, 'error', { level: 'error' })

  const previousNewrelicLog = loadFromLocalStorage('newrelicLog')
  if (previousNewrelicLog) {
    // eslint-disable-next-line no-console
    console[previousNewrelicLog.level](previousNewrelicLog.message)
    removeFromLocalStorage('newrelicLog')
  }
}

addLocaleData([...en, ...es, ...ja, ...de])
const history = createBrowserHistory()
const { store, persistor } = configureStore(history)

// expose store when run in Cypress
if (window?.Cypress) {
  window.store = store
  window.storage = window.localStorage
}

const renderApp = component => {
  render(
    <Provider store={store}>
      <Router history={history}>
        <PersistGate loading={null} persistor={persistor}>
          <LocaleProvider>
            <IntlGlobalProvider>
              <ErrorBoundary FallbackComponent={ErrorMessage}>
                <Init>
                  <BatchWorker
                    interval={15000}
                    jobs={BATCH_JOB_LIST(store.dispatch)}
                  >
                    <ScrollbarMemory />
                    <DownloadsListener />
                    <ScrollToTop>{component}</ScrollToTop>
                  </BatchWorker>
                </Init>
              </ErrorBoundary>
            </IntlGlobalProvider>
          </LocaleProvider>
        </PersistGate>
      </Router>
    </Provider>,
    document.getElementById('root')
  )
  hot(module)(component)
}

renderApp(
  <StrictMode>
    <AppWrapper>
      <Routes />
      <NewSignUp />
      <LoginModal />
      <ForgotPasswordModal />
      <KeyboardShortcutsModal />
      <UpdatePasswordModal />
      <ResetPasswordModal />
      <PlaybackErrorModal />
      <Notifications />
      <ModalWarning />
    </AppWrapper>
  </StrictMode>
)

if (module.hot) {
  module.hot.accept('../../apps/public/routes', () => {
    const newRoutes = require('../../apps/public/routes').default
    renderApp(newRoutes)
  })
  module.hot.accept('../../reducers', () => {
    const nextCreateRootReducer = require('../../reducers/index').default
    store.replaceReducer(nextCreateRootReducer(history))
  })
}
